import { createStores } from '../store/utils';
import { ResponsibleGamingProduct } from '../../services/responsible-gaming/types';
import { ResponsibleGamingStore } from './types';

export const responsibleGaming = createStores<ResponsibleGamingStore>({
    annualReport: null,
    askDepositLimit: undefined,
    askLoginDurationLimit: undefined,
    askLossLimit: undefined,
    isAnnualReportLoaded: null,
    isMaltaPanelVisible: false,
    isPanicTimeoutActive: false,
    isResponsibleGamingPanelVisible: false,
    isSelfExclusionTimeoutActive: false,
    isUnapprovedSessionReminderLoaded: false,
    loginDurationLimitEndDate: null,
    panicTimeoutEndDate: new Date(),
    selfExclusionTimeoutEndDate: new Date(),
    selfExclusionUntilFurtherNotice: undefined,
    timeout: {
        [ResponsibleGamingProduct.CASINO]: undefined,
        [ResponsibleGamingProduct.HORSE_RACING]: undefined,
        [ResponsibleGamingProduct.POKER]: undefined,
        [ResponsibleGamingProduct.SPORTSBOOK]: undefined,
    },
    unApprovedSessionReminder: null,
});
